<template lang="pug">
.sheet(v-bind:style="[backgroundStyle,elevationStyle]" )
    slot
</template>

<script setup>
    import { computed } from 'vue'

    const props = defineProps({
        color: {
            type: String,
            default: 'white',
            validator: (value) => {
                // バリデーションロジック
                return ['white', 'gray', 'gradation', 'red'].includes(value)
            }
        },
        elevation: {
            type: String,
            default: 'middle',
            validator: (value) => {
                // バリデーションロジック
                return ['low', 'middle', 'high', 'none'].includes(value)
            }
        }
    })

    const backgroundStyle = computed(() => {
        switch (props.color) {
            case 'white':
                return { 'background-color': '#ffffff' }
            case 'gray':
                return { 'background-color': '#F4F5F7' }
            case 'gradation':
                return {
                    background: 'linear-gradient(to right, #ffffff, #000000)'
                }
            case 'red':
                return {
                    'background-color': '#FFEDEF'
                }
            default:
                return { 'background-color': '#ffffff' }
        }
    })

    const elevationStyle = computed(() => {
        switch (props.elevation) {
            case 'low':
                return { 'box-shadow': '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24)' }
            case 'middle':
                return { 'box-shadow': '0px 3px 6px rgba(0, 0, 0, 0.16), 0px 3px 6px rgba(0, 0, 0, 0.23)' }
            case 'high':
                return { 'box-shadow': '0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)' }
            case 'none':
            default:
                return {}
        }
    })
</script>

<style scoped></style>
